<div class="overlay">
  <div class="age-verification">
    <div class="age-verification_logo">
      <stxt-svg-icon [iconConfig]="logo" class="age-verification_logo__img"></stxt-svg-icon>
      <stxt-svg-icon [iconConfig]="logoText" class="age-verification_logo__text"></stxt-svg-icon>
    </div>
    <div class="age-verification_body">
      <div class="age-verification_header">
        <p>VIRTUALLY IRRESISTIBLE AIs</p>
      </div>
      <div class="age-verification_agreement">
        <p>
          By entering, you affirm that you are
          <span>at least 18 years of age and above the age of majority</span>
          in the jurisdiction you are accessing the website from and you consent to viewing explicit
          content.
        </p>
        <span>
          By clicking “Agree and Enter”, you must read and agree to our
          <a [href]="ETermsOfService.TermsOfUse" target="_blank">Terms of Use</a>
          and
          <a [href]="ETermsOfService.Privacy" target="_blank">Privacy Policy</a>
          , and affirm under penalty of perjury that you meet the age and legal requirements listed
          above.
        </span>
      </div>
      <stxt-button
        ngbAutofocus
        class="age-verification_btn-confirm"
        [buttonConfig]="confirmAgeBtn"
        (click)="confirmAge()"
        (keydown.enter)="confirmAge()"
      >
        {{ confirmAgeBtn.text }}
      </stxt-button>
      <stxt-button
        ngbAutofocus
        class="age-verification_btn-close"
        [buttonConfig]="closeBtn"
        (click)="closeModal()"
        (keydown.enter)="closeModal()"
      >
        {{ closeBtn.text }}
      </stxt-button>
    </div>
  </div>
</div>
